import React from "react"

const Skiplinks = () => (
    <ul id="skip" aria-label="Accès rapide">
        <li><a href="#works" className="skip-link bold">Réalisations</a></li>
        <li><a href="#contact" className="skip-link bold">Contact</a></li>
    </ul>
)


export default Skiplinks
